import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { AppRoute } from "../types/routes";

export const useNavigation = () => {
  const navigate = useNavigate();

  const push = useCallback(
    (route: AppRoute | string, state?: any) => {
      navigate(route, { state });
    },
    [navigate]
  );

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const replace = useCallback(
    (route: AppRoute | string, state?: any) => {
      navigate(route, { replace: true, state });
    },
    [navigate]
  );

  return useMemo(
    () => ({
      push,
      goBack,
      replace,
    }),
    [push, goBack, replace]
  );
};
